import { createExternalStore } from "@client/utils/createExternalStore";

// Open-state for the unified "General Round Notes" drawer (SP-2152 / SP-2153).
// `memberId` selects which recommender to show first: `null` means the viewer's
// own note ("My general notes", editable for active recommenders). The triggers
// (the header notebook icon, the proposals-page card, the per-recommender
// affordance on a proposal's notes tab) render outside the round provider the
// drawer renders inside, so this module store bridges them. See
// `createExternalStore`.
type GeneralNotesState = { open: boolean; memberId: string | null };

const store = createExternalStore<GeneralNotesState>({
  open: false,
  memberId: null,
});

/** `useVisitedNavItems` key for the header notebook icon's "unseen" dot. */
export const GENERAL_NOTES_NAV_KEY = "general-notes";

/**
 * Open the drawer focused on a recommender (`memberId`), or on the viewer's own
 * note (`null`, the default) — which is editable when the viewer is an active
 * recommender.
 */
export const openGeneralNotes = (memberId: string | null = null) =>
  store.set({ open: true, memberId });

export const setGeneralNotesOpen = (open: boolean) =>
  store.set({ ...store.get(), open });

export const useGeneralNotes = (options?: { resetOnUnmount?: boolean }) =>
  store.useValue(options);
